import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';

@Injectable({
  providedIn: 'root'
})
export class EfateCakeTopologyApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getEfateCakeTopologyBySetupPk(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/cakeTopology/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateCakeTopology(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/cakeTopology';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }
}
